import { createRequest, RequestConfig } from '../../core/libs/api';

export type NewNoAuthFeedback = {
  rating: number;
  orderId: number;
  description?: string;
};

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/add_order_feedback2',
};

export const addNoAuthFeedbackRequest = ({
  hash,
  feedback,
}: {
  hash: string;
  feedback: NewNoAuthFeedback;
}) =>
  createRequest({
    url: `${config.url}?hash=${hash}`,
    method: config.method,
    body: JSON.stringify(feedback),
  });
